import Data from '../../States/Data';
import Helper from '../../Models/Helper';
import Scripture from '../../Models/Scripture';

export default class Collector {
	async collect(verses, allow, highlight) {
		const chapters = await this.chapters(verses, allow);
		const requests = await this.chapterRequests(chapters);
		const contents = await this.chapterContents(chapters, requests);

		let structure = await this.structure(verses, contents, highlight);
		structure = this.percentage(structure);
		return structure;
	}

	async chapters(verses, allow) {
		const mapping = {};
		for (const verse of verses) {
			const info = await Scripture.infoByCode(verse);
			const book = info.book.code;
			if (!mapping[book]) {
				if (!allow) allow = [];
				const expand = allow.includes(info.book.code);
				mapping[book] = {verses: 0, expand, chapters: []};
			}

			mapping[book].verses++;
			const chapter = info.chapter.code;
			if (!mapping[book].chapters.includes(chapter))
				mapping[book].chapters.push(chapter);
		}

		let chapters = [];
		for (const index in mapping) {
			const book = mapping[index];
			if (book.expand || (book.verses <= 10))
				chapters = chapters.concat(book.chapters);
		}

		return chapters;
	}

	async chapterRequests(chapters) {
		const requests = [];
		for (const chapter of chapters) {
			const info = await Scripture.infoByCode(chapter);
			const request = Data.relative(`books/${info.book.code}/${chapter}`);
			requests.push(request);
		}

		return requests;
	}

	async chapterContents(chapters, requests) {
		const contents = {};
		const responses = await Promise.all(requests);
		for (let index = 0; index < responses.length; index++) {
			const response = responses[index];
			contents[chapters[index]] = response;
		}

		return contents;
	}

	async structure(verses, chapter_contents, highlight) {
		const result = [];
		let book = {};
		let list = await Scripture.sortVerses(verses);
		for (const verse of list) {
			const info = await Scripture.infoByCode(verse);
			if (!Helper.is(book) || (book.info.book.code != info.book.code)) {
				if (Helper.is(book)) result.push(book);
				book = {info, partial: false, verses: [], percentage: 0};
			}

			const reference = {};
			reference.name = info.verse.name;
			reference.book = info.book.code;
			reference.chapter = info.chapter.number;
			reference.verses = [info.verse.number];

			let scripture = '';
			const chapter = chapter_contents[info.chapter.code];
			if (chapter) {
				scripture = await Scripture.verseByChapter(chapter.html, info.verse.number);
				if (Array.isArray(highlight))
					scripture = this.highlight(scripture, highlight);
			}
			else book.partial = true;

			const item = {info, reference, scripture};
			book.verses.push(item);
		}

		if (Helper.is(book)) result.push(book);
		return result;
	}

	percentage(structure) {
		let max = 0;
		for (const book of structure)
			if (book.verses.length > max)
				max = book.verses.length;

		for (const book of structure) {
			const percentage = Math.ceil((book.verses.length / max) * 100);
			book.percentage = percentage;
		}

		return structure;
	}

	highlight(scripture, highlight) {
		const list = highlight.join('|');
		const pattern = `(${list})`;
		const expression = new RegExp(pattern, 'ig');
		const replace = '<span class="highlight">$1</span>';
		if (!expression.test(scripture)) scripture = Helper.normalize(scripture);
		scripture = scripture.replace(expression, replace);
		return scripture;
	}
}